import type { TGroupedTableColumn } from 'App/dashboards/_components/DashboardGroupedTable'
import { translate } from 'i18n/i18n'

export const getCropColumn = <Row extends { cropName: string | null }>(): TGroupedTableColumn<Row> => ({
  key: 'crop',
  header: translate.phrases.banyanApp('Crop'),
  value: (row) => row.cropName ?? '',
  render: (row) => row.cropName ?? '-',
  collapseRepeats: true,
})
